<template>
  <div class="centered-container">
    <!-- Name Box -->
    <div class="content-box">
      <div class="box-heading">
        <h3>Who are you?</h3>
      </div>
      <div class="box-content">
        <input
          v-model="name"
          type="text"
          placeholder="Enter a name"
          @keyup.enter="finish"
        />
      </div>
    </div>

    <!-- Finish List of Things Button -->
    <button @click="finish" class="finish-button" :disabled="!canFinish">
      Join
    </button>
  </div>
</template>

<script>
export default {
  props: {
    addName: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      name: "",
    };
  },
  computed: {
    canFinish() {
      return this.name.trim() !== "";
    },
  },
  methods: {
    async finish() {
      if (this.canFinish) {
        this.addName(this.name);
      }
    },
  },
};
</script>

<style scoped>
.content-box .box-content input {
  width: 100%;
}

.finish-button {
  width: 100%;
  max-width: 280px;
  margin-left: 0;
}

@media (max-width: 600px) {
  .finish-button {
    max-width: none;
    min-height: 44px;
  }
}
</style>
